import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  wrapper: {
    maxWidth: 370,
    fontSize: 13,
    lineHeight: 1.23,
    color: '#747474',
  },
  link: {
    color: '#747474',
  },
}));
